document.addEventListener('DOMContentLoaded', function () {
  var hasBeenWarned = false; // 是否已经因为真正点击提交、且当时 Size 未选而被正式警告过

  function isSizeSelected() {
    var valueEl = document.querySelector('.dropdown-button-gsw__value');
    return valueEl && valueEl.textContent.trim() !== 'Select a Size';
  }

  function sync() {
    if (isSizeSelected()) {
      hasBeenWarned = false; // Size 真正选中后，警告状态重置
    }
    var shouldSuppress = !hasBeenWarned;
    document.querySelectorAll('.errorOptions[data-nameinput="globo-option-0"]').forEach(function (el) {
      if (shouldSuppress) {
        if (el.style.display !== 'none') {
          el.dataset.suppressedByFix = '1';
          el.style.setProperty('display', 'none', 'important');
        }
      } else if (el.dataset.suppressedByFix === '1') {
        el.style.removeProperty('display');
        delete el.dataset.suppressedByFix;
      }
    });
  }

  // 改动任何选项时同步一次；Globo 内部可能有轻微异步延迟，
  // 所以在改动后 100ms / 400ms 各再补查一次，不用持续监听，有限次数即可覆盖
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input && input.matches && input.matches('input[type="radio"][name^="globo-option-"]')) {
      sync();
      setTimeout(sync, 100);
      setTimeout(sync, 400);
    }
  }, true);

  // 点击 Add to cart / sticky 按钮时，记录警告状态并同步
  document.addEventListener('click', function (e) {
    if (e.target.closest('buy-buttons button, product-sticky-bar button')) {
      if (!isSizeSelected()) {
        hasBeenWarned = true;
      }
      sync();
      setTimeout(sync, 100);
      setTimeout(sync, 400);
    }
  }, false);
});